import React from 'react';

import {
	LegendContainer,
	BarLegendItem,
	LegendBarIcon,
	LegendText,
} from './styles';

export const ListTreeLegend = ({ data, colors }) => {
	return (
		<LegendContainer>
			{data.map((name, index) => (
				<BarLegendItem key={name}>
					<LegendBarIcon style={{ background: colors[index] }} />
					<LegendText>{name}</LegendText>
				</BarLegendItem>
			))}
		</LegendContainer>
	);
};
